import {Component, ChangeDetectionStrategy} from '@angular/core';
import {CardComponent} from "../../../shared-module/components/card/card.component";
import {IconComponent} from "../../../shared-module/components/icon/icon.component";
import { DatePipe } from "@angular/common";

@Component({
    selector: 'app-breakdownandmaintenance',
    imports: [
    CardComponent,
    IconComponent,
    DatePipe
],
    templateUrl: './breakdownandmaintenance.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './breakdownandmaintenance.component.scss'
})
export class BreakdownandmaintenanceComponent {
  public timelineEntries: { date: Date, description: string }[] = [
    {
      date: new Date(),
      description: "Wij hebben diverse aanpassingen gedaan op het netwerk, echter hebben die nog niet geleid tot een concrete oplossing. Momenteel wordt er nog volop onderzoek gedaan en gewerkt aan een oplossing."
    },
    {
      date: new Date(),
      description: "Wij hebben diverse aanpassingen gedaan op het netwerk, echter hebben die nog niet geleid tot een concrete oplossing. Momenteel wordt er nog volop onderzoek gedaan en gewerkt aan een oplossing."
    },
    {
      date: new Date(),
      description: "Wij hebben diverse aanpassingen gedaan op het netwerk, echter hebben die nog niet geleid tot een concrete oplossing. Momenteel wordt er nog volop onderzoek gedaan en gewerkt aan een oplossing."
    },
    {
      date: new Date(),
      description: "Wij hebben diverse aanpassingen gedaan op het netwerk, echter hebben die nog niet geleid tot een concrete oplossing. Momenteel wordt er nog volop onderzoek gedaan en gewerkt aan een oplossing."
    }
  ];
}
